import { enUS, sv } from 'date-fns/locale';

const locale = { sv, en: enUS };

locale.sv.options.weekStartsOn = 1;
locale.en.options.weekStartsOn = 1;

export default locale;
